/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Plan_First_Meeting_TitleInputs */



/**
* | output |
* | --- |
* | "First conversation" |
*
* @param {Nudge_Plan_First_Meeting_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_plan_first_meeting_title = /** @type {((inputs?: Nudge_Plan_First_Meeting_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Plan_First_Meeting_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Eerste gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Première conversation")
	return /** @type {LocalizedString} */ ("First conversation")
});